import type { Infer } from 'superstruct';
import { assign, object, string } from 'superstruct';

import { PaginationQuery, SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewGMBTemplateDto } from './gmb-template.dto';

const GMBTemplateSortableFields: (keyof ViewGMBTemplateDto)[] = [
	'id',
	'name',
	'createdAt',
	'updatedAt',
	'archived',
	'imported',
] as const;

export const DEFAULT_GMB_TEMPLATE_SORT = 'updatedAt';
export const DEFAULT_GMB_TEMPLATE_SORT_DIR = 'desc';

export const ListGMBTemplateSort = SortQueryDefaulted(
	GMBTemplateSortableFields,
	DEFAULT_GMB_TEMPLATE_SORT,
	DEFAULT_GMB_TEMPLATE_SORT_DIR
);

export const ListGMBTemplateQueryDto = assign(
	PaginationQuery,
	ListGMBTemplateSort,
	object({ search: string() })
);

export type ListGMBTemplateQueryDto = Infer<typeof ListGMBTemplateQueryDto>;
